import styled from "styled-components";
import Colors from "../../themes/Colors";

const CardAdsInfoHolder = styled.div`
  .cardGeneral {
    position: static;
    padding-left: 10px;
    padding-bottom: 10px;
    z-index: 996;
    height: auto;
    line-height: 25px;
    background-color: ${Colors.primary};
    font-size: 16px;
    text-align: center;
    border-radius: 8px;
    width: 100%;
    float: none;
    margin: 0;
    padding-right: 10px;
    min-width: 0;

    @media only screen and (max-width: 1400px) {
      .impacts-container {
        line-height: 20px;
      }
    }
    .buttonAudienceDetails {
      margin-top: 6px;
    }
  }
  .infoDate {
    margin-top: 10px;
    margin-bottom: 1px;
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    color: ${Colors.onPrimarySoft};
  }
  .brandClientNameContainer {
    background-color: ${Colors.snow};
    border-radius: 8px;
    margin-right: 0;
    padding: 2px 6px;
   }
   .brandClientName {
    margin: 0;
    color: ${Colors.primaryAccent};
    font-weight: 500;
    font-size: 14px;
   }
`;

export default CardAdsInfoHolder;